import { render, staticRenderFns } from "./FilesGrid.vue?vue&type=template&id=38127ee8&scoped=true&"
import script from "./FilesGrid.vue?vue&type=script&lang=js&"
export * from "./FilesGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38127ee8",
  null
  
)

export default component.exports